export default __webpack_public_path__ + "static/media/desktop-image-hero-1.91901d0d.jpg";